import {AfterViewInit, Component, ElementRef, OnDestroy, QueryList, ViewChildren} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Store} from '@ngrx/store';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {isTemplateId} from '../../../shared/model/template-id';
import {PathElement} from '../../../shared/model/tree';
import {NavigationService} from '../../../shared/services/navigation.service';
import {
  AppState,
  getAuthIsAdmin,
  getTreeLocalPath,
  getTreePath,
  getTreeSource
} from '../../../state-management/reducers';
import {RenderedProcess} from "../../../shared/model/rendered/rendered-process";
import {UpdateTreeElementText} from "../../../state-management/actions/tree.actions";

@Component({
    selector: 'pm-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.css'],
    standalone: false
})
export class BreadcrumbsComponent implements AfterViewInit, OnDestroy {
  editText = new FormControl();
  editing = false;

  path: PathElement[] = [];
  pathSubscription = this.store$.select(getTreePath).subscribe((path) => {
    if (path?.length > 0) {
      this.cancelEdit()
      this.editText.setValue(path[0]?.label || '')
    }

    this.path = path;
  });

  localPath$ = this.store$.select(getTreeLocalPath)
  isAdmin$ = this.store$.select(getAuthIsAdmin);
  currentTreeSource = this.store$.select(getTreeSource);

  @ViewChildren('input') private dropDownDivList: QueryList<ElementRef>;

  constructor(private navigationService: NavigationService, private store$: Store<AppState>) {
  }

  ngOnDestroy() {
    this.pathSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dropDownDivList.changes.subscribe((list: QueryList<ElementRef>) => {
      if (list.length > 0) {
        list.first.nativeElement.focus();
      }
    });
  }

  getRouterLink(element: PathElement | RenderedProcess): Observable<string> {
    return this.currentTreeSource.pipe(map(source => {
      if (isTemplateId(source)) {
        return decodeURI(this.navigationService.getTemplateUrl(source, element.id));
      }
      return this.navigationService.getNavigationUrl(element.id);
    }))
  }

  canEdit(pathElement: PathElement) {
    return this.path.indexOf(pathElement) === 0;
  }

  toggleEdit() {
    if (this.editing && this.editText.value !== this.path[0].label) {
      window.setTimeout(() => {
        this.store$.dispatch(new UpdateTreeElementText({
          id: this.path[0].id,
          label: this.editText.value
        }))
      }, 0);
    }
    this.editing = !this.editing;
  }

  shouldHide(pathElement: PathElement) {
    return this.canEdit(pathElement) && this.editing;
  }

  cancelEdit() {
    this.editing = false;
    this.editText.setValue(this.path[0]?.label || '');
  }
}
